'use strict';

var commonHelper = require('../helpers/common');
var validation = require('./clientSideValidation');

var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper-product-registration').data('url');
var minChars = 1;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

var scrollAnimate = require('base/components/scrollAnimate');

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper-product-registration');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
    $('.site-search').removeClass('active');
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    var container = $(scope).parents('.site-search').find('.suggestions-inner-wrapper');
    if (($(container).scrollTop() + $(container).innerHeight()) >= $(container)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var $header = $('.page > header');
    var $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
    var top;

    if (isMobileSearch(scope)) {
        top = parseInt($header.css('top'), 10);
        if ($header.hasClass('offset')) {
            $('.suggestions-inner-wrapper').height($(window).height() - $header.height()).parent().css('top', ($header.height() + top));
        } else {
            $('.suggestions-inner-wrapper').height($(window).height() - $header.height()).parent().css('top', $header.height());
        }

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    } else if ($('.suggestions-inner-wrapper').height() > $(window).height()) {
        $('.suggestions-inner-wrapper').height($(window).height() - $header.height());
        handleMoreContentBelowIcon(scope);
        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-lg-block');
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count').parents('.site-search').addClass('active');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $('.site-search').removeClass('active');
    }
}

/**
 * Toggle Search on Mobile
 */
function toggleMobileSearch() {
    $('.search-mobile-trigger').on('click', function () {
        $('.search-mobile').slideToggle();
    });
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        var new_endpoint = getSuggestionsWrapper(scope).data('url');
        $.ajax({
            context: scope,
            // url: endpoint + encodeURIComponent($(scope).val()),
            url: new_endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        $(scope).siblings('.reset-button').removeClass('d-lg-block');
        clearModals();
        getSuggestionsWrapper(scope).empty();
        $('.site-search').removeClass('active');
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

// Logic for restricting future dates selection by customer
/**
 * For non datepicker
 */
function restrictFutureDate() {
    var dtToday = new Date();

    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();

    if (month < 10) {
        month = '0' + month.toString();
    }
    if (day < 10) {
        day = '0' + day.toString();
    }

    var maxDate = year + '-' + month + '-' + day;
    $('#purchaseddate').attr('max', maxDate);
}
/**
 * For datepicker settings
 */
function addDatePicker() {
    var placehold = $('#purchaseddatepicker').attr('data-placeholder');

    $('#purchaseddatepicker').datepicker({
        maxDate: 0,
        dateFormat: placehold,
        onSelect: function (dateText, inst) {
            $(inst).val(dateText);
            $('#purchaseddate').attr('value', dateText);
            var regDate = $(this).datepicker("getDate");
            $('#purchaseddate').attr('value', regDate.getFullYear() + '-' + ('0' + (regDate.getMonth() + 1)).slice(-2) + '-' + ('0' + regDate.getDate()).slice(-2));
        }
    });
}
/**
 * Validate the form
 */
function formValidationInit() {
    validation.invalid();
    validation.submit();
    validation.buttonClick();
}

module.exports = function () {
    // Quick product reg form
    if ($('#productSearchForm').length === 0) {
        addDatePicker();
    }
    // For handling other place text box, based on Others selection from dropdown
    $('body').on('change', '#purchaseplaces', function () {
        if (this.value == 'Others') {
            $('div.oplace').show();
        } else {
            $('div.oplace').hide();
        }
    });

    $(window).on('load', function() {
        var userProfileEmail = ((typeof customerProfileEmail !== 'undefined') && (customerProfileEmail.length > 0)) ? customerProfileEmail : '';
        var userProfileFirstName = ((typeof customerProfileFirstName !== 'undefined') && (customerProfileFirstName.length > 0)) ? customerProfileFirstName : '';
        var userProfileLastName = ((typeof customerProfileLastName !== 'undefined') && (customerProfileLastName.length > 0)) ? customerProfileLastName : '';
        var userProfileAdd2Emaillist = ((typeof customerProfileAdd2Emaillist !== 'undefined') && (customerProfileAdd2Emaillist.length > 0)) ? customerProfileAdd2Emaillist : '';

        if((typeof customerProfileEmail !== 'undefined') && (customerProfileEmail.length > 0))  {
            $('#SelectYourProductDiv').removeClass('d-none');       // .show();
        }
        else {
            if ( !$("#SelectYourProductDiv").hasClass('d-none') ) {
                $('#SelectYourProductDiv').addClass('d-none');      // .hide();
            }
        }

        if(userProfileEmail.length > 0) {
            $('#dwfrm_ProductRegistrationEmail_email').val(userProfileEmail);
            var rdonly = ((typeof customerProfileAuthenticated !== 'undefined') && (customerProfileAuthenticated.length > 0) && (customerProfileAuthenticated === 'true')) ? true : false;
            if(rdonly) {
                $('#dwfrm_ProductRegistrationEmail_email').attr("readonly", 'readonly');
            }
        }
        else {
            var userProfileEmail = ((typeof redirectedCustomerProfileEmail !== 'undefined') && (redirectedCustomerProfileEmail.length > 0)) ? redirectedCustomerProfileEmail : '';
            if(userProfileEmail.length > 0) {
                $('#dwfrm_ProductRegistrationEmail_email').val(userProfileEmail);
                // $('#dwfrm_ProductRegistrationEmail_email').attr("readonly", true);
            }
        }
        if(userProfileFirstName.length > 0) {
            $('#dwfrm_ProductRegistrationEmail_firstname').val(userProfileFirstName);
            // $('#dwfrm_ProductRegistrationEmail_firstname').attr("readonly", true);
        }
        if(userProfileLastName.length > 0) {
            $('#dwfrm_ProductRegistrationEmail_lastname').val(userProfileLastName);
            // $('#dwfrm_ProductRegistrationEmail_lastname').attr("readonly", true);
        }
        if(userProfileAdd2Emaillist.length > 0) {
            $('#dwfrm_ProductRegistrationEmail_addtoemaillist').val(userProfileAdd2Emaillist);
            $('#dwfrm_ProductRegistrationEmail_addtoemaillist').attr("checked", true);
        }
    });

    // LAXMI changed the below logic because 'input.search-product-register' will not be available on page load in new product registration page...
    $('body').on('keyup focus change', 'input.search-product-register', function () {
    // $('input.search-product-register').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    toggleMobileSearch();

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.suggestions').hide();
            $('.site-search').removeClass('active');
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-lg-block');
    });

    $(window).smartresize(function () {
        if ($('.suggestions').length && window.matchMedia('(max-width: 48em)').matches) {
            positionSuggestions('input.search-field');
        }
    });

    $('body').on('click touchend', '.in-stock-filter', function (e) {
        e.preventDefault();

        var inStock = $('.in-stock-filter');
        var option = null;

        if (inStock.is(':checked')) {
            option = true;
        }

        var url = $(this).data('url');
        $.spinner().start();

        $.ajax({
            url: url,
            data: {
                instock: option,
                selectedUrl: $(this).data('href')
            },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('click touchend', '.registration-suggestion-result', function (e) {
        e.preventDefault();
        var $this = $(this);
        var productName = $this.data('name');
        var url = $this.prop('href');
        // $('.product-step.result').empty();

        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                $('span.pidUnavailable').hide();
                $(".primary-category").val("");
                $('.sub-category-result').empty();
                $('.product-step.result').empty();
                $('.product-step.result').html(response);

                $('.search-product-register').val(productName);
                $('.suggestions').hide();
                scrollAnimate($('.product-step.result'));
                if ($('div.oplace').length > 0) {
                    $('div.oplace').hide();
                }
                restrictFutureDate();
                addDatePicker();
                formValidationInit();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('keypress', 'input.search-product-register', function (e) {
        $('span.pidUnavailable').hide();
        if (e.keyCode == 13) {
            e.preventDefault();
            var url = ($('input.productRegisterUrl').val()).replace('prodId', $('input.search-product-register').val());
            // $('.product-step.result').empty();
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (response) {
                    $('.product-step.result').html(response);
                    if ($('div.oplace').length > 0) {
                        $('div.oplace').hide();
                    }
                    restrictFutureDate();
                    commonHelper.updateCanonicalURL($('.js-canonical-url'));
                    formValidationInit();
                    addDatePicker();
                    $.spinner().stop();
                },
                error: function (data, textStatus, xhr) {
                // error: function () {
                   // $(".primary-category").val("");
                   // $('.sub-category-result').empty();
                   // $('.product-step.result').empty();
                    $('span.pidUnavailable').show();
                    $.spinner().stop();
                }
            });
        }
    });

    $('body').on('change', '.primary-category', function (e) {
        e.preventDefault();

        var optionValue = $(this).val();
        var url = $(this).data('url');

        if ($('.sub-category-result').length) {
            $('.sub-category-result').empty();      // don't remove it; just empty it...
        }
        if ($('.product-step.result').length) {
            $('.product-step.result').empty();      // don't remove it; just empty it...
        }

        if (optionValue === '') {
            $('.sub-category-result').empty();
        } else {
            $.spinner().start();

            $.ajax({
                url: url,
                data: {
                    cgid: optionValue
                },
                method: 'GET',
                success: function (response) {
                    $('.sub-category-result').html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $('body').on('change', 'select.product-registration-result', function (e) {
        e.preventDefault();

        var pid = $(this).val();
        var url = $(this).data('url');

        $('.product-step.result').empty();

        if (pid !== '') {
            $.spinner().start();
            $.ajax({
                url: url,
                data: {
                    pid: pid
                },
                method: 'GET',
                success: function (response) {
                    $('.product-step.result').html(response);
                    if ($('div.oplace').length > 0) {
                        $('div.oplace').hide();
                    }
                    restrictFutureDate();
                    formValidationInit();
                    $.spinner().stop();
                    addDatePicker();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $('body').on('change', 'select.sub-category', function (e) {
        e.preventDefault();

        var $ths = $(this).parent();
        var optionValue = $(this).val();
        var url = $(this).data('url');

       // if ($('.product-registration-result').length) {
       //     $('.product-registration-result').remove();
       // }

        var itemCount = $(this).attr('count');
        //if (itemCount === '1') {
        //    $('.sub-category-result').empty();
        //}
        if ($ths.find('.form-group').length) {
            $ths.find('.form-group').remove();      // here, we should remove it...
        }
        if ($('.product-step.result').length) {
            $('.product-step.result').empty();      // don't remove it; just empty it...
        }        

        $.spinner().start();

        $.ajax({
            url: url,
            data: {
                cgid: optionValue
            },
            method: 'GET',
            success: function (response) {
                $ths.append(response);
                var ctr = 0;
                $('select.sub-category').each(function () {
                    ctr += 1;
                    $(this).attr('count', ctr);
                });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });


    $('#product-registration-generic-signup').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var url = $(this).attr('action');

        // console.log('data.content.registration(generic)..................................');

        $.spinner().start();
        $('#email-for-reference').val($('#dwfrm_ProductRegistrationEmail_email').val());
        ///////////////////////////////////////// $form.find('.js-subscribe-email').attr('disabled', true);
        /////// $('.prod-registration__innerblock').removeClass("disabled");

        $('.places-of-purchase-slot').empty();

        $.ajax({
            url: url,
            type: 'post',
            data: $form.serialize(),
            success: function (data) {
                if(data.status) {
                    $('.prod-registration__innerblock').removeClass("d-none");
                }
                // console.log(data.content.placesOfPurchase);
                // displayMessage(data, $form);

                $('#SelectYourProductDiv').removeClass('d-none');
                $('.places-of-purchase-slot').append(data);
                $.spinner().stop();
            },
            error: function (err) {
                console.log(err);
                //displayMessage(err, $form);
                $.spinner().stop();
            }
        });
    });

    $('body').on('submit', '#productRegistrationFormRegular', function (e) {
        //e.preventDefault();

        var firstname = $("#product-registration-signup").find('input[name="dwfrm_ProductRegistrationEmail_firstname"]').val();
        var lastname = $("#product-registration-signup").find('input[name="dwfrm_ProductRegistrationEmail_lastname"]').val();
        var email = $("#product-registration-signup").find('input[name="dwfrm_ProductRegistrationEmail_email"]').val();
        var addToEmailList = $("#product-registration-signup").find('input[name="dwfrm_ProductRegistrationEmail_addtoemaillist"]').val();

        console.log("11111111 :: firstname>>" + firstname + "; lastname>>" + lastname + "; email>>" + email + "; addToEmailList>>" + addToEmailList );

        var $form = $("form#productRegistrationFormRegular");
        ////// console.log("action12---->>>" + $form.attr('action'));
        ////// console.log("firstname---->>>" + $("#product-registration-signup").serialize());
        $form.find('input[name="dwfrm_ProductRegistrationForm_firstname"]').val(firstname);
        $form.find('input[name="dwfrm_ProductRegistrationForm_lastname"]').val(lastname);
        $form.find('input[name="dwfrm_ProductRegistrationForm_email"]').val(email);
        $form.find('input[name="dwfrm_ProductRegistrationForm_addtoemaillist"]').val(addToEmailList);

       // $form.submit();       // $form.trigger( "submit" );
        $('#productRegistrationFormRegular').submit(function() {
            console.log("Submitted...........");
        });
        //document.getElementById("productRegistrationFormRegular").submit();
    });

    $('body').on('submit', '#productRegistrationFormGeneric', function (e) {
        var firstname = $("#product-registration-generic-signup").find('input[name="dwfrm_ProductRegistrationEmail_firstname"]').val();
        var lastname = $("#product-registration-generic-signup").find('input[name="dwfrm_ProductRegistrationEmail_lastname"]').val();
        var email = $("#product-registration-generic-signup").find('input[name="dwfrm_ProductRegistrationEmail_email"]').val();
        var addToEmailList = $("#product-registration-generic-signup").find('input[name="dwfrm_ProductRegistrationEmail_addtoemaillist"]').val();

        console.log("3333333333 :: firstname>>" + firstname + "; lastname>>" + lastname + "; email>>" + email + "; addToEmailList>>" + addToEmailList );

        var $form = $("form#productRegistrationFormGeneric");
        ////// console.log("action12---->>>" + $form.attr('action'));
        ////// console.log("firstname---->>>" + $("#product-registration-generic-signup").serialize());
        $form.find('input[name="dwfrm_ProductRegistrationForm_firstname"]').val(firstname);
        $form.find('input[name="dwfrm_ProductRegistrationForm_lastname"]').val(lastname);
        $form.find('input[name="dwfrm_ProductRegistrationForm_email"]').val(email);
        $form.find('input[name="dwfrm_ProductRegistrationForm_addtoemaillist"]').val(addToEmailList);

        // $form.submit();      // $form.trigger( "submit" );
        $('#productRegistrationFormGeneric').submit(function(){
            console.log("Submitted...........");
        });
        //document.getElementById("productRegistrationFormRegular").submit();
    });

    $('#product-registration-signup').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var url = $(this).attr('action');

        // console.log('data.content.registration(regular)..................................');

        $.spinner().start();
        $('#email-for-reference').val($('#dwfrm_ProductRegistrationEmail_email').val());
        ///////////////////////////////////////// $form.find('.js-subscribe-email').attr('disabled', true);

        $('.places-of-purchase-slot').empty();

        $.ajax({
            url: url,
            type: 'post',
            data: $form.serialize(),
            success: function (data) {
                // console.log(data.content.placesOfPurchase);
                // displayMessage(data, $form);

                $('#SelectYourProductDiv').removeClass('d-none');
                $('.places-of-purchase-slot').append(data);
                $.spinner().stop();
            },
            error: function (err) {
                console.log(err);
                //displayMessage(err, $form);
                $.spinner().stop();
            }
        });
    });

    $('body').on('change', 'select.places-of-purchase', function (e) {
        e.preventDefault();

        var optionValue = $(this).val();
        var url = $(this).data('url');

        $('.places-of-purchase-result').empty();

        if ($('.product-registration-result').length) {
            $('.product-registration-result').remove();
        }

        //var itemCount = $(this).attr('count');
        //if (itemCount === '1') {
        //    $('.purchase-place-result').empty();
        //}

        $.spinner().start();

        $.ajax({
            url: url,
            data: {
                cgid: optionValue
            },
            method: 'GET',
            success: function (data) {
                if (data.success && data.redirect && data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                }
                else {
                    $('.places-of-purchase-result').html(data);
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    /*
    $('body').on('click touchend', '.prod-registration', function (e) {
        e.preventDefault();

        var url = $(this).data('url');
        console.log('135000>>' + url);

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            data: {
                selectedUrl: $(this).data('href')
            },
            method: 'GET',
            success: function (response) {
                // parseResults(response);
                console.log('135100>>' + response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
    */
};
